import { module } from 'modujs'
import { Swiper } from 'swiper';
import { EffectCards, Parallax, A11y } from 'swiper/modules';
import gsap from "gsap";
import CustomEase from 'gsap/CustomEase';
gsap.registerPlugin(CustomEase)

const CLASS = {
    SHOW_CARDS: `has-show-card`,
}
export default class extends module {
    constructor(m) {
        super(m);

        this.indexOfDiscoveredCards = [0];

        this.$container = this.$('container')[0]
        this.$toggleCards = this.$('toggle-cards')[0]

        this.$swiperContainer = this.$('swiper')[0]
        this.$refresh = this.$('refresh')[0]
        this.$next = this.$('next')[0]
        this.$prev = this.$('prev')[0]
        this.$slides = this.$('slides');
        this.$inners = this.$('inners');
        this.$buttons = this.$('buttons');

        this.clickNext = this.manageClickNext.bind(this);
        this.clickPrev = this.manageClickPrev.bind(this);
        this.clickRefresh = this.manageClickRefresh.bind(this);
        this.onSlideChange = this.manageSlideChange.bind(this);

        this.swiper = new Swiper(this.$swiperContainer, {
            modules: [EffectCards, Parallax, A11y],
            a11y: true,
            effect: "cards",
            grabCursor: true,
            parallax: true,
            cardsEffect: {
                slideShadows: false,
                perSlideOffset: 8,
                perSlideRotate: 4,
                rotate: true
            }
        });

        this.events = {
            click: {
                'toggle-cards': 'toggleCards'
            }
        }

        // Check URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('intro') === '0') {
            this.toggleCards();
            this.$container.classList.add('-no-delay')
        }
    }

    toggleCards() {
        this.$container.classList.add(CLASS.SHOW_CARDS)
        this.shuffle(false);
        this.enterAnimation()
    }

    enterAnimation = () => {
        CustomEase.create("smooth", "0.38, 0.005, 0.215, 1")
        gsap.set(this.$inners, {y: "135vh", opacity: 1, x:0, onComplete: () => {
            this.$slides.forEach((slide, i, array) => {
                let getter = gsap.getProperty(slide)
                const data = {
                    y: getter("y"),
                }
                const currentInner = this.$inners[i];
                var tl = gsap.timeline();
                tl.to(currentInner, {y: data.y - 20, delay: (array.length - i) * 0.125, duration: 0.5, ease: "power3.out"})
                tl.to(currentInner, {y: data.y, ease: "power4.out"})
                tl.to(this.$buttons, {y: 0, opacity: 1, ease: "smooth", duration: 0.5, delay: 0.2})
            })
        }})
    }

    manageClickRefresh() {
        CustomEase.create("smooth", "0.38, 0.005, 0.215, 1")
        var tl = gsap.timeline();
        tl
            .to(this.$swiperContainer, {scale: 0, duration: 0.6, ease: "smooth"})
            .to(this.$swiperContainer, { opacity: 0, duration: 0.6, ease: "smooth-2"}, "<")
            .set(this.$swiperContainer, {scale: 1, opacity: 1, onComplete: () => this.shuffle(true)})
    }

    shuffle(shouldAnimate=true) {
        const wrapper = this.$swiperContainer.children[0]
        let colors = []
        let prevFirstEl = wrapper.children[0];
        for (var i = wrapper.children.length; i >= 0; i--) {
            const currentEl = wrapper.children[Math.random() * i | 0]
            const color = gsap.getProperty(currentEl.children[0], "--color-theme")
            wrapper.appendChild(currentEl);
            colors.push(color)
        }

        for(let i = 0 ; i < colors.length ; i++){
            const prev = colors[i - 1];
            const current = colors[i];
            const next = colors[i + 1];

            if(prev && prev == current){
                this.shuffle();
                return;
            }

            if(next && next == current){
                this.shuffle();
                return;
            }
        }

        const currentFirstEl = this.$swiperContainer.children[0].children[0];
        if(currentFirstEl === prevFirstEl){
            this.shuffle();
            return
        }
        this.$inners = this.$('inners');
        this.swiper.destroy();
        this.swiper = new Swiper(this.$swiperContainer, {
            modules: [EffectCards, Parallax, A11y],
            a11y: true,
            effect: "cards",
            grabCursor: true,
            parallax: true,
            activeIndex: 0,
            cardsEffect: {
                slideShadows: false,
                perSlideOffset: 8,
                perSlideRotate: 4,
                rotate: true
            },
            on: {
                init: () => shouldAnimate && this.enterAnimation()
            }
        });
    }

    manageSlideChange(e) {
        this.indexOfDiscoveredCards.push(e.activeIndex)
        if(this.indexOfDiscoveredCards.length == this.swiper.slides.length){
            this.indexOfDiscoveredCards = [];
        }
    }

    init() {
        this.swiper.on('slideChange', this.onSlideChange)
        window.addEventListener("resize", this.resize)
        this.$refresh.addEventListener("click", this.clickRefresh)
        this.$next.addEventListener("click", this.clickNext)
        this.$prev.addEventListener("click", this.clickPrev)
    }

    

    destroy() {
        this.swiper.destroy();
        this.$refresh.removeEventListener("click", this.clickRefresh)
        this.$next.removeEventListener("click", this.clickNext)
        this.$prev.removeEventListener("click", this.clickPrev)
    }

    manageClickNext() {
        if(this.swiper.activeIndex == this.swiper.slides.length - 1){
            this.swiper.slideTo(0)
        }
        else{
            this.swiper.slideNext();
        }
    }

    manageClickPrev() {
        if(this.swiper.activeIndex == 0){
            this.swiper.slideTo(this.swiper.slides.length - 1)
        }
        else{
            this.swiper.slidePrev();
        }
    }
}
